import { render, staticRenderFns } from "./ClientWrapper.vue?vue&type=template&id=8bdf24c6"
import script from "./ClientWrapper.vue?vue&type=script&lang=js"
export * from "./ClientWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports